import PropTypes from 'prop-types';

export const UserProps = {
  Id: '_id',
  Username: 'username',
  Email: 'email',
  Score: 'score',
  Scorer: 'scorer',
  Rank: 'rank',
  ProfilePicture: 'profilePicture',
};

export const UserPropsTypes = {
  [UserProps.Id]: PropTypes.string,
  [UserProps.Username]: PropTypes.string,
  [UserProps.Email]: PropTypes.string,
  [UserProps.Score]: PropTypes.number,
  [UserProps.Scorer]: PropTypes.string,
  [UserProps.Rank]: PropTypes.number,
  [UserProps.ProfilePicture]: PropTypes.string,
};
